import { gzip } from 'pako';

const Base62CodingSpace = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";

const bigZero = BigInt(0);
const bigEight = BigInt(8);
const bigSixtyTwo = BigInt(62);


function bigIntToBase62(num) {
	if (num === bigZero) return Base62CodingSpace[0];
	let result = '';
	const base = bigSixtyTwo;
	while (num > bigZero) {
		const rem = num % base;
		result = Base62CodingSpace[Number(rem)] + result;
		num = num / base;
	}
	return result;
}

function bytesToBigInt(bytes) {
	let result = bigZero;
	for (let byte of bytes) {
		result = (result << bigEight) + BigInt(byte);
	}
	return result;
}

function base62EncodeFromBytes(bytes) {
	const num = bytesToBigInt(bytes);
	return bigIntToBase62(num);
}

export default function compressAndBase62Encode(data) {
	try {

		const jsonString = typeof data === "string" ? data : JSON.stringify(data);

		const textEncoder = new TextEncoder();
		const inputData = textEncoder.encode(jsonString);

		const compressedData = gzip(inputData);
		const base62EncodedString = base62EncodeFromBytes(compressedData);

		return base62EncodedString;
	} catch (error) {
		console.error("Error during compression or encoding:", error, data);
		throw error;
	}
}